import * as React from "react";
const SvgText = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0.63 3.81 8.23 10.19", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.892 14H5.614V5.39H8.862V3.808H0.63V5.39H3.892V14Z", fill: "#454545" }));
export default SvgText;
